import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Popover from "@material-ui/core/Popover";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CloseIcon from "@material-ui/icons/Close";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import {
  OSSDatePicker,
  dateAdjustedForTimezone,
  formatDate
} from "@oss/components";

const useStyles = makeStyles(theme => ({
  input: { padding: 10 },
  popup: {
    padding: [[theme.spacing(1), theme.spacing(2)]],
    width: 212,
    border: "1px solid #ccc",
    boxShadow: "none",
    display: "flex",
    flexDirection: "column"
  },
  popupControls: { alignSelf: "flex-end" },
  endAdornment: {
    position: "absolute",
    right: 5,
    top: 5,
    display: "flex",
    alignItems: "center"
  },
  calendar: {
    background: "#666",
    color: "white",
    padding: 3,
    borderRadius: 4
  },
  endDate: { marginTop: theme.spacing(2) }
}));

const OSSSplitDatesFilter = ({ query, filter }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  //from the filter config, the name of the query param holding the values
  const {
    start_name = null,
    end_name = null,
    onSelect,
    withTime = false
  } = filter;

  //deriving the current value for the date pickers from the query values
  //no need to store the values in local component state
  const currentValues = [query[start_name], query[end_name]];
  const startDate =
    typeof currentValues[0] === "string"
      ? currentValues[0].replace("T00:00:00Z", "")
      : currentValues[0];
  const endDate =
    typeof currentValues[1] === "string"
      ? currentValues[1].replace("T00:00:00Z", "")
      : currentValues[1];

  //update the query on change
  const handleClear = event => {
    event.stopPropagation();
    onSelect(start_name, "");
    onSelect(end_name, "");
  };

  const handleStartChange = date => {
    onSelect(
      start_name,
      `${formatDate(date, "yyyy-MM-dd")}${withTime ? "T00:00:00Z" : ""}`
    );
  };

  const handleEndChange = date => {
    onSelect(
      end_name,
      `${formatDate(date, "yyyy-MM-dd")}${withTime ? "T23:59:59Z" : ""}`
    );
  };

  const openPopover = event => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "popover" : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const dateAdornments = () => {
    return (
      <div className={classes.endAdornment}>
        {(startDate || endDate) && (
          <>
            <CalendarTodayIcon className={classes.calendar} />

            <IconButton onClick={handleClear} size="small" title="Clear values">
              <CloseIcon />
            </IconButton>
          </>
        )}
        <IconButton onClick={handleClose} size="small" title="save and close">
          <ArrowDropDownIcon />
        </IconButton>
      </div>
    );
  };

  return (
    <>
      <TextField
        id="outlined-basic"
        placeholder="Modified Date"
        variant="outlined"
        onClick={openPopover}
        fullWidth
        InputProps={{
          endAdornment: dateAdornments(),
          classes: { input: classes.input }
        }}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        TransitionComponent={Collapse}
        classes={{
          paper: classes.popup
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
      >
        <div className={classes.popupControls}>
          <IconButton onClick={handleClose} size="small" title="Save and close">
            <ArrowDropUpIcon />
          </IconButton>
        </div>

        <OSSDatePicker
          id="start_date"
          inputVariant="outlined"
          label="From"
          value={startDate ? dateAdjustedForTimezone(startDate) : null}
          onChange={handleStartChange}
          autoOk={true}
          maxDate={endDate ? dateAdjustedForTimezone(endDate) : new Date()}
          InputLabelProps={{
            shrink: true
          }}
        />
        <OSSDatePicker
          className={classes.endDate}
          id="end_date"
          inputVariant="outlined"
          label="To"
          value={endDate ? dateAdjustedForTimezone(endDate) : null}
          onChange={handleEndChange}
          autoOk={true}
          minDate={startDate ? dateAdjustedForTimezone(startDate) : false}
          InputLabelProps={{
            shrink: true
          }}
        />
      </Popover>
    </>
  );
};

export default OSSSplitDatesFilter;
